import { apiSlice } from 'src/features/api/api-slice';
import { ApiResponse } from 'src/common/interfaces';
import {
  GenerateBadgeImageBody,
  GenerateBadgeImageData,
  PublicProfileGeneralData,
  PublicProfileGeneralDataParams,
  UserBadge,
} from 'src/common/interfaces/public-profile';

export const PUBLIC_PROFILE_URL = 'public-profile';

export const publicProfileApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPublicProfileGeneralData: builder.query<ApiResponse<PublicProfileGeneralData>, PublicProfileGeneralDataParams>({
      query: ({ username }: PublicProfileGeneralDataParams) => ({
        url: PUBLIC_PROFILE_URL,
        params: {
          username,
        },
      }),
    }),

    putPublicBadgeImage: builder.mutation<ApiResponse, { userPublicId: number; username: string }>({
      query: ({ userPublicId, username }) => ({
        method: 'PUT',
        url: 'badges/public-profile/image',
        body: { userPublicId, username },
      }),
    }),

    getUserBadges: builder.query<ApiResponse<UserBadge[]>, PublicProfileGeneralDataParams>({
      query: ({ username }: PublicProfileGeneralDataParams) => ({
        url: `users/badges`,
        params: {
          username,
        },
      }),
    }),

    generateBadgeImage: builder.mutation<ApiResponse<GenerateBadgeImageData>, GenerateBadgeImageBody>({
      query: (body: GenerateBadgeImageBody) => ({
        url: `badges/public-profile/generate`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useGetPublicProfileGeneralDataQuery,
  usePutPublicBadgeImageMutation,
  useGetUserBadgesQuery,
  useGenerateBadgeImageMutation,
} = publicProfileApiSlice;
